import { render, staticRenderFns } from "./WheelAndManometer.vue?vue&type=template&id=36ebdc26"
import script from "./WheelAndManometer.vue?vue&type=script&lang=js"
export * from "./WheelAndManometer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports